import React, { useCallback, useEffect, useState } from 'react';
import service from './../../services/catalogos';
import './Catalogos.scss';

import Catalogo from '../../components/catalogo/Catalogo';
import Title from '../../components/title/Title';

const Catalogos = props => {

    const [registros, setRegistros] = useState([]);

    const getList = useCallback(async () => {
        const res = await service.getList({ params: { active: true }, sort: 'ordem' });
        setRegistros(res.rows.filter(e=>e.active===true));
    },[]);

    useEffect(() => {
        getList();
    }, [getList]);

    const renderItems = _ => {
        if (registros.length > 0) {
            return registros.map((c, index) => {
                return <Catalogo key={index} data={c} />;
            });
        } else {
            return <div>Carregando...</div>
        }
    }

    return (
        <div className="background paginaCatalogos">
            <Title title="Catálogos" />
            <div className="container">
                <div className="content">
                    {renderItems()}
                </div>
            </div>
        </div>
    )
};

export default Catalogos;